import React, { useEffect, useState } from "react";
import axios from "axios";
import { TextField } from "@material-ui/core";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

import { StyledFileInputWrapper } from "../../styles/styledFileInput";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

const ServiceFieldsInput = ({
  serviceId = null,
  connectionFields,
  setCheckedFields
}) => {
  const { t } = useTranslation("services");
  const [fields, setFields] = useState(null);
  const [fetchingFields, setFetchingFields] = useState(true);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    axios.get(`/api/fields?service.id=${serviceId}`, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setFields(response.data["hydra:member"]);
        setFetchingFields(false);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }, []);

  const handleChange = (e) => {
    let key = e.target.id;
    let data = e.target.value;
    if (e.target.type === "file") {
      data = e.target.files[0];
    }
    setCheckedFields({ ...connectionFields, [key]: data });
  };

  if (fetchingFields) {
    return <Skeleton
      variant="rect"
      height={46}
    />;
  }

  if (Object.keys(fields).length === 0) {
    return "";
  }

  return (
    fields.map((field) => (
      <>
        {field.type === "file" ?
          <StyledFileInputWrapper>
            <div className="file-desc">{t("serviceFieldsInput." + field.name)}</div>
            <div className="added-file">
              <label htmlFor={field.name}>
                <span className="icon-light-add-connection" />
                <input
                  id={field.name}
                  type="file"
                  onChange={handleChange}
                />
              </label>
              {connectionFields && connectionFields.hasOwnProperty("filePath") &&
              <p>{connectionFields.filePath.name}</p>}
            </div>
          </StyledFileInputWrapper> :
          <TextField
            id={field.name}
            label={t("serviceFieldsInput." + field.name)}
            onChange={handleChange}
            type={field.name === "password" ? "password" : "text"}
          />}
      </>
    ))
  );
};

export default ServiceFieldsInput;